import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  padding: 10px;
  background-color: #EEEEEE;
  color: #000;
  position: fixed;
  bottom: 0;
  width: 100%;
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <p>MKS Sistemas © {currentYear} Todos os direitos reservados</p>
    </FooterContainer>
  );
};

export default Footer;